
import DatePicker       from "vue2-datepicker"
import { VueEditor }    from "vue2-editor"

const components = {
    DatePicker: DatePicker,
	VueEditor: VueEditor,
}

export default components



// WEBPACK FOOTER //
// ./src/config/components.js